import {Buttons} from './Buttons';
export default Buttons;